<template>
    <div>
        <div class="modal-header">
            <button type="button" class="close" @click="hideModal()" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">Utwórz danie</h4>
        </div>
        <div class="modal-body">
            <food-edit :food="food" :mode="'create'" ref="foodEdit">
                <template slot="multi_portion_food_portion_amount">
                    <div class="clearfix"/>
                    <div class="col-xs-2 text-left mt-3">
                        <label class="control-label" for="portionAmount">Ilość</label>
                    </div>
                    <div class="col-xs-2 mt-3">
                        <input type="number"
                               class="form-control form-control-xs"
                               id="portionAmount"
                               :min="food.isMultiPortionFood() ? 1 : 0.1"
                               :step="0.5"
                               :max="food.isMultiPortionFood() ? food.portions : 999"
                               v-bind:value="food.portion.amount"
                               v-on:input="getPortionAmountOnInputListener(food, $event)"
                               v-on:change="getPortionAmountOnChangeListener($event)"
                        >
                    </div>
                </template>
            </food-edit>
        </div>
        <div class="modal-footer">
            <slot name="prevModal"></slot>
            <permission-tooltip
                :permission="canCreateFood"
                :tooltip="{top: true, bottom: false, attach: false}"
            >
                <loading-button :disabled="!canCreateFood()" :loading="isLoading" :status="status" @click="storeOrUpdate">
                    <i class="fa fa-save"></i>
                    Dodaj i zapisz do mojej bazy
                </loading-button>
            </permission-tooltip>
        </div>
    </div>
</template>

<style scoped>
    .in {
        display: block;
    }

    .products-table {
        font-size: 13px;
    }
</style>
<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';

    import {productFactory} from '../../../factory/product.factory';
    import {foodFactory} from "../../../factory/food.factory";
    import uuid from "uuid4";
    import {Portion} from "../../../model/portion.model";
    import {trans} from "../../../app";
    import {FoodService} from "../../../services/FoodService";
import {DIETITIAN_FREE, DIETITIAN_TEST} from "../../../utils/roles";

    export default {
        data() {
            return {
                food: null,
                day: null,
                isLoading: false,
                status: '',
            };
        },
        async created() {
          await this.fetchOwnFoodsCount();
        },
        computed: {
            ...mapState({
                modalData: state => state.modal.data,
                schema: state => state.menu.schema,
                modals: state => state.modals,
            }),
            ...mapGetters([
                'getDayById',
                'configuration',
                'ownFoodsCount',
                'userRole'
            ])
        },
        methods: {
            ...mapActions(['fetchOwnFoodsCount']),
            ...mapMutations([
                'hideModal',
                'showModal',
            ]),
            remove(productId) {
                this.food.removeProduct(productId);
            },
            addProduct(product) {
                this.food.addProduct(productFactory.createFromDto(product));
            },
            getPortionAmountOnInputListener(food, $event) {
                const inputValue = Number($event.target.value);
                const minValue = Number($event.target.min);
                const maxValue = Number($event.target.max);

                if (inputValue >= minValue && inputValue <= maxValue) {
                    food.portion.amount = inputValue;
                } else if (inputValue < minValue) {
                    food.portion.amount = minValue;
                } else if (inputValue > maxValue) {
                    food.portion.amount = maxValue;
                }
            },
            getPortionAmountOnChangeListener($event) {
                const inputValue = Number($event.target.value);
                const minValue = Number($event.target.min);
                const maxValue = Number($event.target.max);

                if (inputValue >= minValue && inputValue <= maxValue) {
                    $event.target.value = inputValue;
                } else if (inputValue < minValue) {
                    $event.target.value = $event.target.min
                } else if (inputValue > maxValue) {
                    $event.target.value = $event.target.max;
                }
            },
            async storeOrUpdate(update = false) {
                this.$refs.foodEdit.validateFood();
                if (!this.food.isValid()) {
                    return;
                }

                this.isLoading = true;
                try {
                    this.food.regenerateHash();

                    const foodWeight = this.food.getTotalWeight();

                    this.food.portion = new Portion(this.food.portion.amount, foodWeight);


                  if (update) {
                    this.food = await FoodService.updateFood(this.food);
                  } else {
                    this.food = await FoodService.storeFood(this.food);
                  }

                    this.status = true;
                    this.$toast.success(trans('app.food_saved'));
                    this.plan.addFood(this.food);
                    await this.fetchOwnFoodsCount();
                    this.modals.pop();
                    this.showModal(this.modals.pop());
                } catch (error) {
                    this.status = false;
                    if (error.response && error.response.status === 409) {
                        if (error.response.data.food_uuids.length === 1) {
                          this.$confirmWarning(trans('app.food_already_exists_in_database_update'),).then(() => {
                            this.food.externalId = error.response.data.food_uuids[0];
                            this.storeOrUpdate(true)
                          }).catch((error) => {
                            this.sentryCaptureException(error);
                            this.status = '';
                          })
                        } else {
                          this.$toast(trans('app.food_already_exists_in_database'));
                        }
                    } else {
                        this.$toast.error(trans('app.food_not_saved'));
                        this.sentryCaptureException(error);
                    }
                }

                this.isLoading = false;
            },
            canCreateFood() {
                if (this.userRole === DIETITIAN_FREE || this.userRole === DIETITIAN_TEST) {
                    return this.ownFoodsCount < 20;
                }
                return true;
            }
        },
        watch: {
            modalData: {
                immediate: true,
                handler: function (data) {
                    if (!data) return;
                    this.day = this.getDayById(data.dayId);
                    this.plan = this.day.getPlan(data.planId);
                    this.food = foodFactory.create(
                        uuid(),
                        null,
                        '',
                        1,
                        null,
                        null,
                        [],
                        null,
                        ''
                    )
                },
            },
        },
    };
</script>
